// extracted by mini-css-extract-plugin
module.exports = {"input":"Input-module__input___1wZha","inputSmall":"Input-module__inputSmall___29SJx","errors":"Input-module__errors___3TcaU","extra":"Input-module__extra___2Nknn"};